<div id="award">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">Star Awardees</h4>
                  <div class="card-body">
                    <p class="inner-lead">Welcome to our school's Star Awardees page! We are proud to recognize and celebrate the outstanding achievements of our students who have excelled in their 10th and 12th board exams.
                    </p>  
                    <p class="inner-lead">Our Star Awardees have demonstrated a commitment to academic excellence, hard work, and dedication to their studies.</p>
                    <p class="inner-lead">At our school, we understand the importance of acknowledging the accomplishments of our students, and our Star Awardees page is a testament to that. We believe that academic excellence should be celebrated, and our Star Awardees page provides a platform to recognize and honor the hard work and dedication of our students. </p>
                    <p class="inner-lead">We take great pride in our Star Awardees, who have set a high bar for academic excellence at our school. Their achievements serve as an inspiration to other students, and we hope that they will continue to strive for greatness in all their endeavors. Our Star Awardees have not only excelled academically but also demonstrated a commitment to leadership, community service, and personal growth.
                    </p>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>